import { render } from "./TruckDeleteFormModal.vue?vue&type=template&id=9b2fea42&lang=pug"
import script from "./TruckDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./TruckDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script